import React from "react";
import { Helmet } from 'react-helmet';

const ErrorPage = () => {
    return (
        <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
            <Helmet>
                <title>Page Not Found | Partnered Management Group</title>
                <meta name="description" content="The page you're looking for doesn't exist. Return to Partnered Management Group's homepage to learn about our fractional project management services." />
                <meta name="robots" content="noindex, follow" />
            </Helmet>
        <div className="text-center">
          <p className="text-base font-semibold text-indigo-600">404</p>
          <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">Page not found</h1>
          <p className="mt-6 text-base leading-7 text-gray-600">Sorry, we couldn’t find the page you’re looking for.</p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <a href="/" className="text-sm font-semibold text-gray-900">
              Go Home <span aria-hidden="true">&rarr;</span>
            </a>
          </div>
        </div>
      </main>
    )
}

export default ErrorPage;